import type { RiskIndexSource } from '@app/src/types/resourceExplorer'
import { Box } from '@mui/material'
import React from 'react'
import { getIndexIcon } from '../RiskIndexIcons/RiskIndexIcon'

interface RiskIndexSourceIconProps {
  source: RiskIndexSource
  size?: number
}

/**
 * Renders a risk index's source logo for the topic cards: larger than the legacy table icon and
 * without the small topic-badge overlay. Reuses the source→logo mapping from RiskIndexIcon; the
 * `fontSize: inherit` rule forces the logo (which hardcodes its own size) to take the given size.
 */
const RiskIndexSourceIcon: React.FC<RiskIndexSourceIconProps> = ({ source, size = 28 }) => (
  <Box
    sx={{
      fontSize: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .MuiSvgIcon-root': { fontSize: 'inherit' },
    }}
  >
    {getIndexIcon(source)}
  </Box>
)

export default RiskIndexSourceIcon
